export function isRoasVectorMonthSet(month) {
  return month !== '' && month !== null && month !== undefined;
}

export function mapRoasVectorFromApi(points) {
  return (points ?? []).map((point, index) => ({
    id: index + 1,
    month: isRoasVectorMonthSet(point.month) ? Number(point.month) : '',
    cumulativeRoasPct: point.cumulativeRoasPct ?? '',
  }));
}

export function mapRoasVectorToApi(points) {
  return (points ?? [])
    .filter(
      (point) =>
        isRoasVectorMonthSet(point.month) &&
        point.cumulativeRoasPct !== '' &&
        point.cumulativeRoasPct !== null &&
        point.cumulativeRoasPct !== undefined
    )
    .map((point) => ({
      month: Number(point.month),
      cumulativeRoasPct:
        typeof point.cumulativeRoasPct === 'number'
          ? point.cumulativeRoasPct
          : Number(point.cumulativeRoasPct),
    }));
}

export function emptyRoasVectorRow(id = 1) {
  return { id, month: '', cumulativeRoasPct: '' };
}

export function hasDuplicateRoasVectorMonths(points) {
  const months = (points ?? [])
    .map((point) => point.month)
    .filter((month) => isRoasVectorMonthSet(month));
  return months.length !== new Set(months).size;
}
